import {TableCell, TableRow} from '@mui/material';
import React from 'react';
import {getCityName, getSpecName, getCountryName} from '../Trans.js'
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {dStr} from '../Util.js';

const StatsRow = (props) => {
	const gStorage = useGlobalStorage();

	function statsRowGetSpecName(id) {
		return getSpecName(gStorage.lists.speclist.list.find(elem => elem.id === id), gStorage.conn.user);
	}

	function getFormattedAddr(obs) {
		const city = gStorage.lists.citylist.list.find(x => x.id === obs.city_id);
		const usr = gStorage.conn.user;

		let a_str = '';

		if (city.country !== usr.def_country) {
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);
			a_str = getCountryName(country, usr) + ', ';
		}

		a_str += getCityName(city, usr) + ', ' + obs.addr;

		return a_str;
	}

	const bg = props.bgcolor ? props.bgcolor : 'inherit';

	return (
		<TableRow style={{backgroundColor: bg}}>
			<TableCell>{props.row_n ? props.row_n : ''}</TableCell>
			<TableCell>{statsRowGetSpecName(props.obs.spec_id)}</TableCell>
			<TableCell>{dStr(props.obs.start_t)}</TableCell>
			<TableCell>{getFormattedAddr(props.obs)}</TableCell>
		</TableRow>
	);
};

export default StatsRow;
